import React from "react";
import Dashboard from "../layouts/Dashboard";
import { Home } from "./Home";
import Polizas from "./polizas/Polizas";
import Siniestros from "./siniestros/Siniestros";
import { DocumentoAM } from "./zoho/DocumentoAM";
import { CredHospAmbulatorio } from "./zoho/CredHospAmbulatorio";
import Zoho from "./zoho/Zoho";
import AdminPolizas from "./polizas/AdminPolizas";
import { GestorUsuario } from "./GestorUsuario";
import { Switch } from "react-router-dom";
import { BannerVam } from "./BannerVam";
import { VisorAll } from "../user/VisorAll";
import { Tarjeta } from "./pages/tarjeta/Tarjeta";
import { TikTok } from "./tiktok/TikTok.jsx";
import { Reports } from "./reportes/Reports";
import { PolicyImportFile } from "./bi/PolicyImportFile";
import { AdminTOTP } from "./totp/AdminTOTP";

export const RoutesPagesVam = () => {
    return (
        <Switch>
            <Dashboard exact path="/vam/home" component={Home} title={"Portal Asegurados VAM"} />
            <Dashboard exact path="/vam/polizas" component={Polizas} title={"Pólizas de Seguros"} />
            <Dashboard exact path="/vam/siniestros" component={Siniestros} title={"Consulta Siniestros"} />
            <Dashboard
                exact
                path="/vam/docs-am/:id?"
                component={DocumentoAM}
                title={"Documentos Siniestros Asistencia Médica"}
            />
            <Dashboard
                exact
                path="/vam/docs-cred-hosp/:id?"
                component={CredHospAmbulatorio}
                title={"Documento Crédito Hospitalario/Ambulatorio"}
            />
            <Dashboard exact path="/vam/zoho" component={Zoho} title={"Zoho"} />
            <Dashboard exact path="/vam/admin" component={AdminPolizas} title={"Administrador selección"} />
            <Dashboard exact path="/vam/visor" component={VisorAll} title={"Usuarios"} />
            <Dashboard exact path="/vam/usuarios-gestor" component={GestorUsuario} title={"Creación Usuarios"} />
            <Dashboard exact path="/vam/bannerPrueba" component={BannerVam} title={"Banner Vam"} />
            <Dashboard
                exact
                path="/vam/tarjeta"
                component={Tarjeta}
                title={"Mi tarjeta"}
                hideNavbar
                hideFooter
                classMainPanel={"w-100"}
            />
            <Dashboard exact path="/vam/tiktok" component={TikTok} title={"TikTok"} />
            <Dashboard exact path="/vam/bi" component={PolicyImportFile} title={"Prodeseg-BI"} />
            <Dashboard excat path="/vam/reportes" component={Reports} title={"Reportes"} />
            <Dashboard excat path="/vam/admin-totp" component={AdminTOTP} title={"Administración MFA"} />
        </Switch>
    );
};
